import { Translate } from "@/app/application/Translate";
import { Box } from "@mui/material";

export const TrainingPlannerTourSteps = [
	{
		selector: '[data-tour="training-page"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingPlanner.Welcome">
					Welcome to the Training Planner. Schedule course and drill sessions on
					the calendar, drag events to reschedule, and create new sessions from
					the Create button or by selecting a time slot.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="training-tabs"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingDashboard.Tabs">
					Use these tabs to switch between Dashboard, Courses, Drills, Archive,
					and Planner. Dashboard shows the overview here; Courses and Drills
					show detailed session management; Archive lists completed sessions;
					Planner helps schedule training.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="training-planner-sidebar"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingPlanner.Sidebar">
					Upcoming sessions list — search and browse scheduled sessions. Blue
					items are course sessions; green are drill sessions. Click a session
					to open its details. Use the list icon in the header to show or hide
					this sidebar.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="training-planner-header"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingPlanner.Header">
					Navigation and Create — use the arrows and Today to move around.
					Switch between Month, Week, and Day views. Use Create to add a new
					course or drill session. You can also click and drag on an empty time
					slot to create a session.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="training-planner-calendar"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.TrainingPlanner.Calendar">
					Calendar — view all scheduled sessions. Click an event to open it.
					Drag events to change their date or time — changes are saved
					automatically. Select an empty slot to open the Create menu.
				</Translate>
			</Box>
		),
	},
];
